import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home"),
  },
  {
    path: "/hacercurriculum",
    name: "hacercurriculum",
    component: () => import("../views/Cv"),
  },
  {
    path: "/preview/:hash",
    name: "preview",
    component: () => import("../views/Preview"),
    props: true,
  },
  
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
